module.exports = __webpack_public_path__ + "static/media/chat.4e469628.svg";